<template lang='pug'>
	div#app
		router-view
		v-alerts
</template>
<script>
export default {
    name: 'App',
    created: function() {
        window.fbAsyncInit = function() {
            FB.init({
                appId: process.env.VUE_APP_FB,
                cookie: false,
                xfbml: true,
                version: 'v4.0'
            })
        };
        (() => {
            const fjs = document.getElementsByTagName('script')[0]
            if (document.getElementById('facebook-jssdk')) {
                return
            }
            const js = document.createElement('script')
            js.id = 'facebook-jssdk'
            js.src = 'https://connect.facebook.net/en_US/sdk.js'
            fjs.parentNode.insertBefore(js, fjs)
        })()
    }
}
</script>
